interface OperationsTableProps {
  onSelectOperation: (id: string) => void;
}

const operations = [
  {
    id: 'OP-2024-1847',
    client: 'Importadora Global S.A.',
    type: 'Importación',
    status: 'En Tránsito',
    statusColor: 'bg-[#EAF2F8] text-[#2F80ED]',
    origin: 'Shanghai, China',
    destination: 'Callao, Perú',
    eta: '2024-06-15',
    value: '$125,400',
    risk: 'medium',
  },
  {
    id: 'OP-2024-1846',
    client: 'Exportadora del Sur Ltda.',
    type: 'Exportación',
    status: 'Documentación',
    statusColor: 'bg-yellow-50 text-[#EAB308]',
    origin: 'Lima, Perú',
    destination: 'Miami, USA',
    eta: '2024-06-12',
    value: '$89,200',
    risk: 'low',
  },
  {
    id: 'OP-2024-1845',
    client: 'Comercial Andina S.A.C.',
    type: 'Importación',
    status: 'En Riesgo',
    statusColor: 'bg-red-50 text-[#EF4444]',
    origin: 'Hamburg, Alemania',
    destination: 'Callao, Perú',
    eta: '2024-06-10',
    value: '$234,800',
    risk: 'high',
  },
  {
    id: 'OP-2024-1844',
    client: 'Distribuidora Pacífico E.I.R.L.',
    type: 'Importación',
    status: 'Completada',
    statusColor: 'bg-green-50 text-[#10B981]',
    origin: 'Tokyo, Japón',
    destination: 'Callao, Perú',
    eta: '2024-06-08',
    value: '$156,900',
    risk: 'low',
  },
  {
    id: 'OP-2024-1843',
    client: 'Textiles Internacionales S.A.',
    type: 'Exportación',
    status: 'En Tránsito',
    statusColor: 'bg-[#EAF2F8] text-[#2F80ED]',
    origin: 'Lima, Perú',
    destination: 'Barcelona, España',
    eta: '2024-06-18',
    value: '$67,500',
    risk: 'low',
  },
];

export default function OperationsTable({ onSelectOperation }: OperationsTableProps) {
  return (
    <div className="bg-white rounded-lg border border-gray-200 overflow-hidden">
      <div className="overflow-x-auto">
        <table className="w-full">
          <thead className="bg-gray-50 border-b border-gray-200">
            <tr>
              <th className="px-4 py-3 text-left text-xs font-semibold text-[#6B7280] uppercase tracking-wider">
                Operación
              </th>
              <th className="px-4 py-3 text-left text-xs font-semibold text-[#6B7280] uppercase tracking-wider">
                Cliente
              </th>
              <th className="px-4 py-3 text-left text-xs font-semibold text-[#6B7280] uppercase tracking-wider">
                Tipo
              </th>
              <th className="px-4 py-3 text-left text-xs font-semibold text-[#6B7280] uppercase tracking-wider">
                Estado
              </th>
              <th className="px-4 py-3 text-left text-xs font-semibold text-[#6B7280] uppercase tracking-wider">
                Ruta
              </th>
              <th className="px-4 py-3 text-left text-xs font-semibold text-[#6B7280] uppercase tracking-wider">
                ETA
              </th>
              <th className="px-4 py-3 text-left text-xs font-semibold text-[#6B7280] uppercase tracking-wider">
                Valor
              </th>
              <th className="px-4 py-3 text-left text-xs font-semibold text-[#6B7280] uppercase tracking-wider">
                Acciones
              </th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-200">
            {operations.map((op) => (
              <tr
                key={op.id}
                className="hover:bg-gray-50 transition-colors cursor-pointer"
                onClick={() => onSelectOperation(op.id)}
              >
                <td className="px-4 py-4">
                  <div className="flex items-center gap-2">
                    <span className="font-semibold text-sm text-[#0A2A43]">{op.id}</span>
                    {op.risk === 'high' && (
                      <div className="w-2 h-2 rounded-full bg-[#EF4444]"></div>
                    )}
                  </div>
                </td>
                <td className="px-4 py-4">
                  <span className="text-sm text-[#0A2A43]">{op.client}</span>
                </td>
                <td className="px-4 py-4">
                  <span className="text-sm text-[#6B7280]">{op.type}</span>
                </td>
                <td className="px-4 py-4">
                  <span className={`px-2 py-1 text-xs font-medium rounded-md ${op.statusColor}`}>
                    {op.status}
                  </span>
                </td>
                <td className="px-4 py-4">
                  <div className="text-xs text-[#6B7280]">
                    <div>{op.origin}</div>
                    <div className="flex items-center gap-1 mt-1">
                      <i className="ri-arrow-down-line text-[#2F80ED]"></i>
                      <span>{op.destination}</span>
                    </div>
                  </div>
                </td>
                <td className="px-4 py-4">
                  <span className="text-sm text-[#6B7280]">{op.eta}</span>
                </td>
                <td className="px-4 py-4">
                  <span className="text-sm font-semibold text-[#0A2A43]">{op.value}</span>
                </td>
                <td className="px-4 py-4">
                  <div className="flex items-center gap-2">
                    <button className="w-8 h-8 flex items-center justify-center rounded-md hover:bg-gray-100 transition-colors cursor-pointer">
                      <i className="ri-eye-line text-[#6B7280]"></i>
                    </button>
                    <button className="w-8 h-8 flex items-center justify-center rounded-md hover:bg-gray-100 transition-colors cursor-pointer">
                      <i className="ri-edit-line text-[#6B7280]"></i>
                    </button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Pagination */}
      <div className="px-4 py-3 border-t border-gray-200 flex items-center justify-between">
        <p className="text-sm text-[#6B7280]">
          Mostrando <span className="font-semibold">1-5</span> de <span className="font-semibold">127</span> operaciones
        </p>
        <div className="flex gap-2">
          <button className="px-3 py-1.5 text-sm border border-gray-200 rounded-md hover:bg-gray-50 transition-colors cursor-pointer whitespace-nowrap">
            Anterior
          </button>
          <button className="px-3 py-1.5 text-sm bg-gradient-to-r from-[#114B7A] to-[#2F80ED] text-white rounded-md cursor-pointer whitespace-nowrap">
            1
          </button>
          <button className="px-3 py-1.5 text-sm border border-gray-200 rounded-md hover:bg-gray-50 transition-colors cursor-pointer whitespace-nowrap">
            2
          </button>
          <button className="px-3 py-1.5 text-sm border border-gray-200 rounded-md hover:bg-gray-50 transition-colors cursor-pointer whitespace-nowrap">
            3
          </button>
          <button className="px-3 py-1.5 text-sm border border-gray-200 rounded-md hover:bg-gray-50 transition-colors cursor-pointer whitespace-nowrap">
            Siguiente
          </button>
        </div>
      </div>
    </div>
  );
}